import { memo } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MapPin } from "lucide-react";

const BOUTIQUE_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_b23b68ca-96f4-4732-840a-c86194f2a639/artifacts/5g1iii6g_IMGP9226.jpg",
    alt: "Intérieur boutique Mediastore Niort",
    title: "Notre boutique",
    subtitle: "104 Rue de la Gare",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_b23b68ca-96f4-4732-840a-c86194f2a639/artifacts/1v4afdug_IMGP9228.jpg",
    alt: "Vitrine Mediastore - Apple Certified",
    title: "Apple Certified",
    subtitle: "Techniciens certifiés Apple",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_b23b68ca-96f4-4732-840a-c86194f2a639/artifacts/wgtrh9ac_IMGP9265.jpg",
    alt: "Boutique Mediastore Niort",
    title: "Notre expertise",
    subtitle: "+10 ans d'expérience",
  },
];

export const BoutiqueSection = memo(() => (
  <section className="section-padding bg-white">
    <div className="container-custom">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Découvrez notre boutique</h2>
        <p className="text-lg text-slate-600">Un espace moderne et professionnel au cœur de Niort</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {BOUTIQUE_PHOTOS.map((photo) => (
          <div key={photo.src} className="relative rounded-2xl overflow-hidden shadow-lg group">
            <img
              src={photo.src}
              alt={photo.alt}
              className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
              width="400"
              height="256"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
              <p className="text-white font-semibold">{photo.title}</p>
              <p className="text-white/70 text-sm">{photo.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link to="/contact">
          <Button size="lg" className="bg-red-600 hover:bg-red-700 gap-2">
            <MapPin className="h-5 w-5" />
            Nous rendre visite
          </Button>
        </Link>
      </div>
    </div>
  </section>
));

BoutiqueSection.displayName = "BoutiqueSection";
